// Returned by the backend when a cursor is expired.
const EXPIRED_CURSOR_CODE = "LINEAGE_PAGINATION_EXPIRED";

// Check if the error is a cursor expired error.
export function isExpiredCursor(error: unknown): boolean {
  if (!error) {
    return false;
  }
  return JSON.stringify(error).includes(EXPIRED_CURSOR_CODE);
}
